<script setup>
import { onMounted } from 'vue'
import { useAppointments } from '@store/appointments.js'
const $appointments = useAppointments()

import { useSettings } from '@store/settings'
const $settings = useSettings()

onMounted(async () => {
    await $appointments.matchAppointmentPreRequirement()
    await $appointments.loadSelectedAppointment()
    await $settings.fetchSettings()
})
</script>
<template>
    <div class="prebook-wrapper">
        <router-view />
    </div>
</template>